import types from './types';

const getChildGalleryRequest = (childId, offset = 0) => ({
  type: types.GET_CHILD_GALLERY_REQUEST,
  childId,
  offset
});

const getChildGallerySuccess = (childId, photos) => ({
  type: types.GET_CHILD_GALLERY_SUCCESS,
  childId,
  photos
});

const getChildGalleryFailure = () => ({
  type: types.GET_CHILD_GALLERY_FAILURE
});

/**
 *
 * @param {File[]} files
 * @param {Number} childId
 */
const uploadPhotosToChildGallery = (files, childId) => ({
  type: types.UPLOAD_PHOTOS_TO_CHILD_GALLERY_REQUEST,
  files,
  childId
});

const uploadPhotosToChildGallerySuccess = () => ({
  type: types.UPLOAD_PHOTOS_TO_CHILD_GALLERY_SUCCESS
});

const uploadPhotosToChildGalleryFailure = error => ({
  type: types.UPLOAD_PHOTOS_TO_CHILD_GALLERY_FAILURE,
  error
});

/**
 * Request to remove a photo from a child's gallery
 * @param {Number} childId
 * @param {Number} groupImageId
 */
const removeImageFromChildGalleryRequest = (groupImageId, childId) => ({
  type: types.REMOVE_PHOTO_FROM_CHILD_GALLERY_REQUEST,
  childId,
  groupImageId
});

const removeImageFromChildGallerySuccess = (childId, groupImageId) => ({
  type: types.REMOVE_PHOTO_FROM_CHILD_GALLERY_SUCCESS,
  childId,
  groupImageId
});

const removeImageFromChildGalleryFailure = error => ({
  type: types.REMOVE_PHOTO_FROM_CHILD_GALLERY_FAILURE,
  error
});

export default {
  getChildGalleryRequest,
  getChildGallerySuccess,
  getChildGalleryFailure,
  uploadPhotosToChildGallery,
  uploadPhotosToChildGallerySuccess,
  uploadPhotosToChildGalleryFailure,
  removeImageFromChildGalleryRequest,
  removeImageFromChildGallerySuccess,
  removeImageFromChildGalleryFailure
};
